<template>
  <div class="supply-chain-intro">
    <!-- 左侧业务板块 -->
    <div class="business-wrap">
      <div class="line-vertical"></div>
      <div class="business-item">
        <div class="icon-box">
          <img src="../../assets/img/icon/a-zhineng15.png" alt="">
        </div>
        <div class="text-content">
          <h2 class="title">供应链咨询+专题培训</h2>
          <p class="desc">战略规划 · 专题培训 · 产品设计</p>
        </div>
        <div class="dot-line"></div>
      </div>

      <div class="business-item">
        <div class="icon-box">
          <img src="../../assets/img/icon/shuzihuaanquan.png" alt="">
        </div>
        <div class="text-content">
          <h2 class="title">供应链公司软件系统</h2>
          <p class="desc">外贸综合服务平台 · 大宗商品供应链系统</p>
        </div>
        <div class="dot-line"></div>
      </div>

      <div class="business-item">
        <div class="icon-box">
          <img src="../../assets/img/icon/zhinengicon-01.png" alt="">
        </div>
        <div class="text-content">
          <h2 class="title">AI 智慧风控报告</h2>
          <p class="desc">行业研究 · 客商画像 · AI 风控报告</p>
        </div>
        <div class="dot-line"></div>
      </div>
    </div>

    <!-- 中间品牌logo区域 -->
    <div class="so-center">
        <div class="so-rings">
        <div class="so-ring so-ring-1"></div>
        <div class="so-ring so-ring-2"></div>
        <div class="so-ring so-ring-3"></div>
        <div class="so-ring so-ring-4"></div>
        <div class="so-logo-wrap">
            <img src="../../assets/img/layout/logo-large.png" alt="中普科技" />
        </div>
        <!-- 装饰圆点 -->
        <span class="so-dot so-dot-1"></span>
        <span class="so-dot so-dot-2"></span>
        <span class="so-dot so-dot-3"></span>
        <span class="so-dot so-dot-4"></span>
        <span class="so-dot so-dot-5"></span>
        <span class="so-dot so-dot-6"></span>
        <span class="so-dot so-dot-orange"></span>
        </div>
    </div>

    <!-- 右侧专家团队 -->
    <div class="team-wrap">
      <div class="team-header">
        <span class="orange-short-line"></span>
        <h3 class="team-title">核心专家团队 <span>| 专业·经验·可信赖</span></h3>
      </div>
      <div class="expert-list">
        <div class="expert-item">
          <div class="avatar"></div>
          <p class="name">海平老师</p>
          <p class="post">总架构师</p>
          <div class="under-line"></div>
        </div>
        <div class="expert-item">
          <div class="avatar"></div>
          <p class="name">赖老师</p>
          <p class="post">方案专家</p>
          <div class="under-line"></div>
        </div>
        <div class="expert-item">
          <div class="avatar"></div>
          <p class="name">艾老师</p>
          <p class="post">技术总监</p>
          <div class="under-line"></div>
        </div>
      </div>
      <div class="team-slogan">
        <span class="orange-quote">「</span>
        打造供应链行业的知识科技特种部队
        <span class="orange-quote">」</span>
        <div class="slogan-line"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SupplyChainIntro",
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.supply-chain-intro {
  width: 100%;
  margin-top: 40px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 40px 20px 40px 60px;
  background: #ffffff;
  background-image: radial-gradient(#d8f0f8 1px, transparent 1px);
  background-size: 40px 40px;
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background: radial-gradient(circle at center, rgba(34, 168, 194, 0.08) 0%, transparent 70%);
    z-index: 0;
  }

  > div {
    position: relative;
    z-index: 1;
  }
}

// 左侧业务模块
.business-wrap {
  width: 42%;
  position: relative;
  .line-vertical {
    position: absolute;
    left: -30px;
    top: 0;
    height: 100%;
    width: 1px;
    background: #36C2D8;
    &::before, &::after, & div {
      content: "";
      position: absolute;
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background: #36C2D8;
      left: -3px;
    }
    &::before { top: 10px; }
    &::after { top: 180px; }
    div { top: 350px; }
  }

  .business-item {
    display: flex;
    align-items: center;
    margin-bottom: 28px;
    gap: 16px;
    .icon-box {
      flex-shrink: 0;
      img{
        width: 50px;
      }
    }
    .text-content {
      .title {
        font-size: 16px;
        font-weight: 700;
        color: #1a1a1a;
        margin: 0 0 6px;
      }
      .desc {
        font-size: 12px;
        color: #666;
        margin: 0;
        line-height: 1.7;
      }
    }
    .dot-line {
      flex: 1;
      height: 1px;
      background: linear-gradient(to right, #22A8C2, transparent);
      position: relative;
      margin-left: 20px;
      &::after {
        content: "";
        position: absolute;
        right: 0;
        top: -3px;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: #22A8C2;
      }
    }
  }
}

// 中间logo
.logo-center {
  width: 16%;
  display: flex;
  flex-direction: column;
  align-items: center;
  .circle-bg {
    width: 220px;
    height: 220px;
    background: radial-gradient(circle, #E6F7FC 0%, transparent 70%);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    &::before {
      content: "";
      position: absolute;
      width: 180px;
      height: 180px;
      border: 1px solid rgba(34, 168, 194, 0.2);
      border-radius: 50%;
    }
    &::after {
      content: "";
      position: absolute;
      width: 140px;
      height: 140px;
      border: 1px solid rgba(34, 168, 194, 0.2);
      border-radius: 50%;
    }
  }
  .orange-line {
    width: 60px;
    height: 2px;
    background: #ff6b35;
    margin-top: 16px;
    position: relative;
    &::after {
      content: "";
      position: absolute;
      right: -4px;
      top: -3px;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background: #ff6b35;
    }
  }
}

// 右侧团队
.team-wrap {
  width: 36%;
  .team-header {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 20px;
    .orange-short-line {
      width: 4px;
      height: 24px;
      background: #ff6b35;
    }
    .team-title {
      font-size: 16px;
      margin: 0;
      font-weight: 700;
      span {
        font-size: 13px;
        color: #666;
        font-weight: normal;
      }
    }
  }

  .expert-list {
    display: flex;
    justify-content: space-between;
    margin-bottom: 22px;
    .expert-item {
      text-align: center;
      width: 30%;
      .avatar {
        width: 90px;
        height: 90px;
        border-radius: 50%;
        background: #f0f9fb;
        margin: 0 auto 20px;
        background-image: url(../../assets/img/home/touxiang.png);
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-position: center;
      }
      .name {
        font-size: 16px;
        font-weight: 600;
        margin: 0 0 4px;
        color: #1a1a1a;
      }
      .post {
        font-size: 12px;
        color: #888;
        margin: 0 0 8px;
      }
      .under-line {
        width: 40px;
        height: 2px;
        background: #22A8C2;
        margin: 0 auto;
      }
    }
  }

  .team-slogan {
    text-align: center;
    font-size: 13px;
    font-weight: 600;
    color: #20B0BC;
    letter-spacing: 2px;
    .orange-quote {
      color: #ff6b35;
      font-size: 16px;
    }
    .slogan-line {
      width: 60px;
      height: 2px;
      background: #ff6b35;
      margin: 12px auto 0;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/components/supplyChainIntro.vue